import {useState} from "react";
import {ActiveShiftsTray, type ActiveShiftsTrayProps} from "./ActiveShiftsTray";
import {useActiveShifts} from "./useActiveShifts";

export type ConnectedActiveShiftsTrayProps = Pick<
  ActiveShiftsTrayProps,
  "regionName" | "onViewMap" | "onViewDispatch" | "onViewTickets" | "brand" | "colorScheme"
> & {regionId: string};

export function ConnectedActiveShiftsTray({regionId, ...props}: ConnectedActiveShiftsTrayProps) {
  const [open, setOpen] = useState(false);
  const data = useActiveShifts(regionId, open);
  return <ActiveShiftsTray {...props} {...data} onOpenChange={setOpen} />;
}
